module.exports = __webpack_public_path__ + "static/media/IMG_1685.602b9d26.JPG";